import Vue from "vue";
import Cognito from "../cognito/cognito";

Vue.use(Cognito);
export default new Cognito();



// WEBPACK FOOTER //
// ./src/plugins/cognito.js